const publicPath = process.env.REACT_APP_ASSET_PATH || '/';

const languageConfig =  {
  lng: ["en", "ru", "tr", "pt", "fr", "it"],
  fallbackLng: "en",
  fallbackNS: "common",
  lowerCaseLng: true,
  ns: "common",
  backend: {
    loadPath: `${publicPath}locales/{{lng}}/{{ns}}.json`,
  },
  keySeparator: ".",
};

export default languageConfig;